import React, { Component } from "react";
import Gettext from "../common/Gettext";
import { withFetch } from "../common/fetch";
import ErrorContainer, { Button } from "../ErrorPopup/Error";
import Spinner from "../Spinners/SimpleSpinner";
import Money from "../Money";

type Props = {
  bid_limit: number,
  style?: Object,
  fetch: Function,
  onDismiss: () => void
};

type State = {
  isRequestInProgress: boolean,
  serverMessage: string
};

class IncreaseBidLimit extends Component {
  props: Props;
  state: State;
  handleRequest: () => any;

  state = {
    isRequestInProgress: false,
    serverMessage: ""
  };

  handleRequest = () => {
    this.setState({
      isRequestInProgress: true
    });
    this.props
      .fetch("/ajax/request-bid-limit")
      .then(json => {
        this.setState({
          isRequestInProgress: false,
          serverMessage: json.message
        });
      })
      .catch(error => console.log(error));
  };

  componentDidMount() {
    this.button.focus();
  }

  render() {
    const { serverMessage, isRequestInProgress } = this.state;

    const limit = (
      <Money>
        {this.props.bid_limit}
      </Money>
    );

    const message = serverMessage ? (
      serverMessage
    ) : (
      <Gettext>Maximum bid is {limit}</Gettext>
    );

    return (
      <ErrorContainer message={message} onDismiss={this.props.onDismiss}>
        {!serverMessage && (
          <Button
            onClick={this.handleRequest}
            ref={button => (this.button = button)}
          >
            {isRequestInProgress && <Spinner />}{" "}
            <Gettext>Increase limit</Gettext>
          </Button>
        )}
      </ErrorContainer>
    );
  }
}

export default withFetch(IncreaseBidLimit);



// WEBPACK FOOTER //
// ./src/components/TradeModals/IncreaseBidLimit.js